// Responsive breakpoints
const size = {
  xs: '320px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px'
};

// Media queries
export const device = {
  xs: `(max-width: ${size.xs})`,
  sm: `(max-width: ${size.sm})`,
  md: `(max-width: ${size.md})`,
  lg: `(max-width: ${size.lg})`,
  xl: `(max-width: ${size.xl})`,
  xxl: `(max-width: ${size.xxl})`
};

// Helper function for mobile-first responsive design
export const responsive = (cssProperty, defaultValue, breakpoints) => {
  let styles = `${cssProperty}: ${defaultValue};`;
  
  for (const [breakpoint, value] of Object.entries(breakpoints)) {
    styles += `
      @media ${device[breakpoint]} {
        ${cssProperty}: ${value};
      }
    `;
  }
  
  return styles;
}; 